import { FunctionComponent, useState } from "react";

import { Modal } from "@/components";
import { InputField } from "@/components/InputField/InputField";
import { useCreatCustomColumnTemplateMutation } from "@/pages/Private/redux/column/column.api";
import { CustomColumnTypes, ListSourceType } from "@/enum/list.enum";
import { Checkbox } from "@/components/Checkbox/Checkbox";
import { PermissionRoles } from "@/enum/permissions";
import { useHasPermissions } from "@/utils/useHasPermissions";

interface SaveCustomColumnTemplateModalProps {
	isOpen: boolean;
	onClose: () => void;
	listSourceType: ListSourceType;
	editor: string;
	initialListId?: number;
	initialTrackerId?: number;
	type: CustomColumnTypes;
}

export const SaveCustomColumnTemplateModal: FunctionComponent<
	SaveCustomColumnTemplateModalProps
> = ({ isOpen, onClose, editor, listSourceType, initialListId, initialTrackerId, type }) => {
	const [templateName, setTemplateName] = useState("");

	const [generalTemplate, setGeneralTemplate] = useState(false);

	const [saveCustomColumnTemplate, { isLoading }] = useCreatCustomColumnTemplateMutation();

	const { hasPermissions } = useHasPermissions();

	const handleSave = async () => {
		await saveCustomColumnTemplate({
			name: templateName,
			listSourceType,
			config: JSON.stringify(editor),
			type,
			initialListId,
			initialTrackerId,
			generalTemplate,
		}).unwrap();

		onClose();
	};

	return (
		<Modal
			handleClose={onClose}
			handleSave={handleSave}
			isLoading={isLoading}
			isOpened={isOpen}
			submitButtonText="Save"
			title="Save Prompt Template"
		>
			<div>
				<InputField
					handleChange={(e) => setTemplateName(e.target.value)}
					label="Template Name"
					name="templateName"
					placeholder="Enter template name"
					value={templateName}
				/>
				{hasPermissions([PermissionRoles.GLOBAL_ADMIN]) && (
					<Checkbox
						isChecked={generalTemplate}
						label="Save as default"
						name="isDefault"
						onChange={() => setGeneralTemplate(!generalTemplate)}
					>
						Should this be available for all organizations?
					</Checkbox>
				)}
			</div>
		</Modal>
	);
};
